import { render, staticRenderFns } from "./DownloadAgent.vue?vue&type=template&id=be474526&scoped=true&"
import script from "./DownloadAgent.vue?vue&type=script&lang=js&"
export * from "./DownloadAgent.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAgent.vue?vue&type=style&index=0&id=be474526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be474526",
  null
  
)

export default component.exports